import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DocumentDataService } from '../../services/document-data.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AlertDialogComponent } from 'src/app/glp-common/components/alert-dialog/alert-dialog.component';
import { AuthService } from '@auth0/auth0-angular';
import { LoggingService } from 'src/app/utilities/logging.service';
import { MemberDataService } from 'src/app/content/home/services/member-data.service';
import { UserService } from 'src/app/services/user.service';
import { ActivityType } from 'src/app/models/ActivityType';
import { TelementryService } from 'src/app/services/telemetry.service';

@Component({
  selector: 'app-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.scss'],
})
export class DocumentsListComponent implements OnInit, AfterViewInit {
  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = ['name', 'downloadLink'];

  @ViewChild(MatPaginator) paginator: MatPaginator;

  @ViewChild(MatSort) sort: MatSort;

  @ViewChild('searchInput') searchInput: ElementRef;

  userEmail:string;
  filterStr: string = '';
  enableSearch: boolean;
  groupId: string = '';
  idType: string;

  constructor(
    private dataService: DocumentDataService,
    public auth: AuthService,
    private dialog: MatDialog,
    private loggingService: LoggingService,
    private memberData: MemberDataService,
    private userService: UserService,
    private telementryService: TelementryService,
  ) {}

  ngOnInit() {
    this.groupId = this.memberData.selectedGroupID || this.userService.user.accountNumber;
    if(this.groupId.length > 6){
      this.groupId =  this.groupId.substring(0,6)
    }
    this.userEmail = this.userService.user.email;

    //default idType is groupId
    if(this.memberData.idType == undefined || this.memberData.idType == null){
      this.idType = 'groupId';
    }
    else{
      this.idType = this.memberData.idType;
    }
    this.dataService.getDocumentList(this.groupId, this.idType).subscribe((list) => {
      let array = list.map((item) => {
        return {
          $key: item.name,
          ...item,
        };
      });
      this.dataSource = new MatTableDataSource(array);
      this.enableSearch = true;
      this.dataSource.filterPredicate = (data, filter) => {
        return this.displayedColumns
          .filter((dc) => dc != 'downloadLink')
          .some((ele) => {
            return data[ele].toLowerCase().indexOf(filter) != -1;
          });
      };
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }

  ngAfterViewInit() {}

  applyFilter(filterValue: string) {
    this.filterStr = filterValue.trim();
    if(this.dataSource)
    {
      if (filterValue.trim() != "")
      {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filterPredicate = (data: any, filter: string) => {
          var c1 = (typeof data.name !== 'undefined' && data.name !== null && data.name.toLowerCase().includes(filter));
          return c1;
        };
        this.dataSource.filter = filterValue;
      }

      this.dataSource.filter = filterValue;
    }
  }


  clickFilter() {
    this.dataSource.filter = this.searchInput.nativeElement.value.trim().toLowerCase();
  }

  downloadFile(name: string, fullName: string) {
    this.dataService.getDocumentFile(name, fullName, this.userEmail,this.groupId, this.idType).subscribe(
      (data) => {
        //window.open(window.URL.createObjectURL(data));
        const element = document.createElement('a');
        element.href = URL.createObjectURL(data.image);
        element.download = name;
        document.body.appendChild(element);
        element.click();
        element.remove();
      },
      (err) => {
        // console.log(err);
        let friendlyError = 'An error occurred while downloading the document';
        this.loggingService.logException(err, 3);
        const errorDialogConfig = new MatDialogConfig();
        errorDialogConfig.data = {
          title: 'Result Download Document',
          message: friendlyError,
          input: 'Accept',
        };
        this.dialog.open(AlertDialogComponent, errorDialogConfig);
      }
    );
  }

  ts_map = {
    "Document Name": "ascending",
  }

 toggleSortingOrder(key: string) {
    if (key in this.ts_map) {
        for (const k in this.ts_map) {
          if (k !== key) {
              this.ts_map[k] = "descending";
          }
        }
        if (this.ts_map[key] === "descending") {
            window.dataLayer.push({'event': 'broker_click', 'click_location':'Plan Documents', 'click_action': `Table Header - ${key} - ascending`});
            this.ts_map[key] = "ascending";
        } else {
            window.dataLayer.push({'event': 'broker_click', 'click_location':'Plan Documents', 'click_action': `Table Header - ${key} - descending`});
            this.ts_map[key] = "descending";
        }
        this.telementryService.trackSentryFeature(ActivityType.ToggleSortingOrder, {
          area: "Document List",
          direction: this.ts_map[key]
        });
    } else {
        console.log(`${key} is not a valid key in the map.`);
    }
  }

  brokerClickPagination(event: any){
    if(event.srcElement.parentElement.ariaLabel != null){
      window.dataLayer.push({'event': 'broker_click', 'click_location': 'Plan Documents', 'click_action': `Pagination - ${event.srcElement.parentElement.ariaLabel}`})
    }
  }

  pageSizeChange(newPageSize: number) {
    window.dataLayer.push({'event': 'broker_click', 'click_location':'Plan Documents', 'click_action': `Filter - ${newPageSize} items per page`});
  }

  handleGtagClick(click_location: string, click_action: string): void {
    window.gTagPush(click_location, click_action)
  }
}
